import {Component, OnInit} from "@angular/core";
import {IOption} from "ng-select";
import {BsModalRef} from "ngx-bootstrap";
import {NgxSpinnerService} from "ngx-spinner";
import {HelperService} from "../services/helper.service";
import {RilrService} from "../services/rilr.service";

@Component({
    selector: 'app-monthly-safety-almaha-print',
    templateUrl: './monthly-safety-almaha-print.component.html',
    styleUrls: ['./monthly-safety-almaha-print.component.scss'],
    providers: [RilrService, HelperService],
})
export class MonthlySafetyAlmahaPrintComponent implements OnInit {

    public masterData: any = {};
    public monthlySafetyID: number;
    public templateType: number;
    public templateOneArray: any = [];
    public templateTwoArray: any = [];
    public companySystemID = this.helperService.getSelectedCompanyId();
    public injuredPersonMultipleOneArr: any[];
    public injuredPersonMultipleTwoArr: any[];

    constructor(public bsModalRef: BsModalRef,
                private helperService: HelperService,
                private spinner: NgxSpinnerService,
                private rilrService: RilrService) {
    }

    ngOnInit() {
        this.spinner.show();
        setTimeout(() => {
            this.reportPrintPreview();
        }, 0);

    }

    public reportPrintPreview() {
        const that = this;
        that.rilrService
            .monthlyPerformancePrintPreviewData()
            .get({
                templateType: that.templateType,
                monthlySafetyID: that.monthlySafetyID,
                companySystemID: that.companySystemID,
            })
            .subscribe(data => {
                const resp = data.data.data;
                that.masterData = resp.reportData;
                that.templateOneArray = resp.detailOne;
                that.templateTwoArray = resp.detailTwo;
                that.injuredPersonMultipleOneArr = data.injuredPersonOne;
                that.injuredPersonMultipleTwoArr = data.injuredPersonTwo;
                that.spinner.hide();
            }, (error) => {
                that.spinner.hide();
            });
    }

    public closeModal() {
        this.bsModalRef.hide();
    }

}



// WEBPACK FOOTER //
// /app/src/app/monthly-safety-almaha-print/monthly-safety-almaha-print.component.ts